import { Modal, ModalProps, Button } from 'antd';
import { CSSProperties } from 'react';
import styled from 'styled-components';

type Props = {
  headerStyle?: CSSProperties;
  bodyStyle?: CSSProperties;
  footerStyle?: CSSProperties;
  contentStyle?: CSSProperties;
};

export default styled(Modal)<ModalProps & Props>`
  border-radius: 8px;
  margin: 10px;
  ${(props) => props.contentStyle as string};
  .ant-modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #cccccc;
    border-radius: 8px 8px 0 0;
    ${(props) => props.headerStyle as string};
    .ant-modal-title {
      font-size: 18px;
      color: #f9f8f8;
      font-weight: 400;
    }
  }
  .ant-modal-body {
    ${(props) => props.bodyStyle as string};
    background: #f9f8f8;
  }
  .ant-modal-footer {
    height: 90px;
    display: flex;
    justify-content: center;
    border-top: none;
    border-radius: 0 0 8px 8px;
    padding: 20px;
    ${(props) => props.footerStyle as string};
  }
`;

export const ButtonStyled = styled(Button)`
  cursor: pointer;
  &.button-primary {
    background: #f6ac00;
    box-shadow: 1px 1px 4px rgb(68 68 68 / 20%);
    border-radius: 5px;
    border: none;
    margin: 0 5px;
    height: 44px;
    .button-label {
      color: #ffffff;
      font-size: 13px;
      text-align: center;
      font-weight: 400;
    }
  }
  &.button-other {
    background: #ffffff;
    box-shadow: 1px 1px 4px rgb(68 68 68 / 20%);
    border-radius: 5px;
    border: 1px solid #f6ac00;
    padding: 9px 60px;
    margin: 0 5px;
    .button-label {
      color: #f6ac00;
      font-size: 13px;
      text-align: center;
      font-weight: 400;
    }
  }
  &.disabled {
    background-color: #acacac;
    cursor: not-allowed;
    border: none;
    .button-label {
      color: #ffffff;
    }
  }
  &.disabled:hover {
    background-color: #acacac;
  }
  &.button-secondary {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    box-shadow: 1px 1px 4px rgba(68, 68, 68, 0.2);
    border-radius: 5px;
    margin: 0 5px;
    padding: 9px 35px;
    height: 44px;
    .button-label {
      color: #777777;
      font-size: 13px;
      text-align: center;
      font-weight: 400;
    }
  }
`;
